/** Etiquetas, colores y formatos del módulo de registro biométrico. */

export const DECISION_ETIQUETA: Record<string, string> = {
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
  MANUAL_REVIEW: 'Revisión manual',
  UNKNOWN: 'Sin decisión',
};

export const DECISION_COLOR: Record<string, string> = {
  APPROVED: '#1f8a5b',
  REJECTED: '#ef4444',
  MANUAL_REVIEW: '#f59e0b',
  UNKNOWN: '#64748b',
};

export const DECISIONES = ['APPROVED', 'REJECTED', 'MANUAL_REVIEW', 'UNKNOWN'] as const;

const PLATAFORMA: Record<string, string> = { ios: 'iOS', android: 'Android', desconocido: 'Sin dato' };
export const etiquetaPlataforma = (p: string) => PLATAFORMA[p.toLowerCase()] ?? (p || 'Sin dato');

/** Los puntajes vienen en 0–100. */
export const fmtPuntaje = (n: number) => (n > 0 ? `${Math.round(n * 10) / 10}%` : '—');

/** Fecha de hoy en Panamá (UTC-5, sin horario de verano), yyyy-mm-dd. */
export function hoyPanama(): string {
  return new Date(Date.now() - 5 * 3600_000).toISOString().slice(0, 10);
}
export function haceDiasPanama(dias: number): string {
  return new Date(Date.now() - 5 * 3600_000 - dias * 86_400_000).toISOString().slice(0, 10);
}
